import { createBrowserHistory } from 'history';
import Qs from 'qs';
import isEmpty from 'lodash/isEmpty';

const browserHistory = createBrowserHistory();

export const redirectToLogin = () => {
  const { pathname, search } = browserHistory.location;
  const query = Qs.parse(search.slice(1));
  if (pathname !== '/login') {
    if (pathname !== '/') query.next = pathname;
    browserHistory.push(
      `/login${isEmpty(query) ? '' : `?${Qs.stringify(query)}`}`,
    );
  }
};

export const getNextPath = () => {
  return new URL(window.location.href).searchParams.get('next');
};

export const redirectToNext = (next) => {
  browserHistory.push(next || getNextPath() || '/');
};

export default browserHistory;
